// GA4 destination for this build; independent of API/environment configuration.
export const analytics = {
  enabled: true,
  measurementId: 'G-N1V25YTDLJ',
  productId: 'personalia',
  appVariant: 'default',
  environment: 'dev',
};
